import { dispatch } from 'store'
import { projectDataSelectors } from 'store/features/projectData/selectors'
import { TAppDispatch, TGetState } from 'store/types'
import { AIAvatarSocketMessageState, IAIAvatarSocketMessage } from './types'
import { aiAvatarSocketHandlers } from './socketHandlers'

export const handleAiAvatarSocketData = (data: IAIAvatarSocketMessage) => {
  switch (data.state) {
    case AIAvatarSocketMessageState.VOICEOVER_GENERATED:
      dispatch(aiAvatarSocketHandlers.processVoiceoverGenerated(data))
      break

    case AIAvatarSocketMessageState.FINISHED:
      dispatch(aiAvatarSocketHandlers.processCompletedAvatar(data))
      break

    case AIAvatarSocketMessageState.ERROR:
      dispatch(aiAvatarSocketHandlers.processFailedAvatar(data))
      break
  }
}

// Replays a past avatar socket event captured while the client was
// disconnected (page refresh / reconnect). It re-applies the event only when a
// still-pending avatar clip matches it, so a stale FINISHED/ERROR can't
// resurrect or fail a clip the user has since resolved. Mirrors
// `handleAiVideoPastSocketData`.
const updatePendingAiAvatarsPerPastSocketData =
  (data: IAIAvatarSocketMessage) => (_: TAppDispatch, getState: TGetState) => {
    const state = getState()
    const pendingAiAvatarMediaItems =
      projectDataSelectors.pendingAiAvatarMediaItems(state)
    if (!pendingAiAvatarMediaItems.length) return

    const hash = data.ai_avatar_video_hash
    const projectId = String(data.ai_avatar_project_id)

    const isDataForPendingItem = pendingAiAvatarMediaItems.some(
      pendingItem =>
        pendingItem.id === hash ||
        pendingItem.assetId === hash ||
        pendingItem.assetId === projectId
    )
    if (isDataForPendingItem) {
      handleAiAvatarSocketData(data)
    }
  }

export const handleAiAvatarPastSocketData = (data: IAIAvatarSocketMessage) => {
  if ('ai_avatar_video_hash' in data) {
    dispatch(updatePendingAiAvatarsPerPastSocketData(data))
  }
}
